import type { LeadCompleteness } from '@viq-admin/types';

/**
 * Should this lead show as incomplete (spec 2026-09-14 §1.4, §3.4)? Only when
 * the backend judged it (`completeness` present, company not off), it misses a
 * requirement, and it hasn't been sent to a CRM — sent leads are done and are
 * never flagged. `undefined` fields (an older backend) are never a finding.
 */
export function isIncompleteUnsent(lead: {
  completeness?: LeadCompleteness | null;
  crmSentAt?: string | null;
}): boolean {
  return lead.completeness?.complete === false && !lead.crmSentAt;
}
